export default __webpack_public_path__ + "static/media/passport.b3f2259b.svg";